import type { RefObject } from "react"
import { useEffect } from "react"

import { animateCounter } from "./animate-counter"

export function useAnimateValueEffect(
    ref: RefObject<HTMLSpanElement | null>,
    duration: number,
    value: number | undefined | null,
    placeholder: string = "\u2014"
): void {
    useEffect(() => {
        let cancelAnimation: (() => void) | null = null

        if (value === null || value === undefined) {
            if (ref?.current) {
                ref.current.textContent = placeholder
            }
            return
        }

        let start = 0
        if (value > 10) {
            start = value * 0.9
        }

        cancelAnimation = animateCounter(start, value, duration, (val) => {
            if (ref?.current) ref.current.textContent = val
        })

        return () => cancelAnimation?.()
    }, [value, ref, placeholder, duration])
}
